module.exports = __webpack_public_path__ + "img/img_fuwujiesao.e1c1e1e6.png";